import React from "react";

export const ListLoadingNotification = () => {
  return (
    <div className="h-14 bg-yellow-200 w-full p-3 flex flex-row items-center justify-center">
      <span className="fa-2x mr-3">
        <i className="fa fa-circle-notch fa-pulse text-blue-500" />
      </span>
      <span>Loading...</span>
    </div>
  );
};

export default ListLoadingNotification;
